import { render, staticRenderFns } from "./customer-baseinvoice.vue?vue&type=template&id=aa47a5ca&scoped=true&"
import script from "./customer-baseinvoice.vue?vue&type=script&lang=js&"
export * from "./customer-baseinvoice.vue?vue&type=script&lang=js&"
import style0 from "./customer-baseinvoice.vue?vue&type=style&index=0&id=aa47a5ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa47a5ca",
  null
  
)

export default component.exports